// New items first
export const sortByDateFn = (a, b) => {
  return new Date(b.created).getTime() - new Date(a.created).getTime();
};
